<ng-container *transloco="let t">
  <div class="admin-card">
    <app-competitor-table [competitors]="competitors" [genders]="genders" [race]="race" [showLoadMoreButton]="true"
                          [applicationFormSettings]="applicationFormSettings"
                          [raceSettings]="raceSettings"
                          [isAdmin]="true" [languages]="languages" (filterChange)="handleFilterChange($event)">
      <div slot="competitorTableAdminLeadingWidgets">
        <app-rounded-button [label]="t('race.management.competitors.register')" (onClick)="onRegister()"
                            [isDisabled]="!isRaceRegistrationEnabled()" [btnClass]="'rounded-button--solid'"><i
          class="bi bi-plus-circle pe-2"></i></app-rounded-button>
      </div>
      <div slot="competitorTableAdminTrailingWidgets">
        <app-admin-actions-header [isPdfVisible]="false" (onExportToXls)="exportCompetitorList('xlsx')">
          <div slot="trailingWidgets">
            <div
              class="d-inline-flex flex-column flex-xl-row align-items-start align-items-xl-center">
              <div class="pb-3 pb-xl-0">

              </div>
              <div class="pb-3 pb-xl-0">
                <app-panel [hasDropdown]="true" [disabled]="false" #importPanel (onClose)="initImportParams()">
                  <div class="dropdown-panel">
                    <div class="pe-2">
                      <app-rounded-button [label]="t('race.management.competitors.import')"
                                          [btnClass]="'rounded-button--button-black-solid'"
                                          (onClick)="importCompetitorList()">
                        <i class="bi bi-file-arrow-up pe-2"></i>
                      </app-rounded-button>
                    </div>
                  </div>
                  <div class="dropdown-content p-3">
                    <div class="admin-card__title">
                      <div class="d-flex justify-content-between align-items-center">
                  <span class="fw-bold">
                    {{ t("race.management.competitors.import.panel.title") }}
                  </span>
                      </div>
                    </div>
                    <div class="pt-3">
                      <div class="">
                <span>
                  <span class="fw-bold">{{ t("race.management.competitors.import.step.1") }}:</span>
                  {{ t("race.management.competitors.import.step.descrtiption.1") }}
                </span>
                      </div>
                      <div class="d-flex justify-content-center align-items-center pt-3">
                        <app-rounded-button [label]="t('Preuzmite preložak')"
                                            [btnClass]="'rounded-button--button-black-solid'"
                                            (onClick)="downloadTemplate()">
                          <i class="bi bi-file-earmark-arrow-down pe-2"></i>
                        </app-rounded-button>
                      </div>
                      <div class="pt-4 pb-3">
                <span>
                  <span class="fw-bold">{{ t("race.management.competitors.import.step.1") }}: </span>
                </span>
                        <span>
                  {{ t("race.management.competitors.import.step.descrtiption.2") }}
                </span>
                      </div>
                      <div class="pb-3">
                        <app-drag-and-drop [fileType]="FileType.XLS" (fileChange)="competitorFileAdded($event)"
                                           [selectedFile]="selectedFile"/>
                      </div>
                      <div class="form-floating mb-3 pb-3">
                        <app-select [hasDefault]="false" [items]="importTypes"
                                    labelKeyPrefix="race.management.competitors.import.type."
                                    label="race.management.competitors.import.type"
                                    (ngModelChange)="onImportTypeChange($event)" [ngModel]="importType"/>
                      </div>
                    </div>
                    <!--    Action buttons row-->
                    <div class="d-flex py-4 align-items-center justify-content-end">
                      <div class="pe-3">
                        <app-rounded-button [label]="t('app.common.cancel')"
                                            [btnClass]="'rounded-button--button-black-solid'"
                                            (onClick)="onImportPanelCancel()">
                        </app-rounded-button>
                      </div>
                      <div>
                        <app-rounded-button [label]="t('app.common.save')" (onClick)="onImportPanelSave()"
                                            [isDisabled]="!selectedFile"></app-rounded-button>
                      </div>
                    </div>
                  </div>
                </app-panel>
              </div>
              <div class="pe-2">
                <app-rounded-button [label]="t('Assign Bibs')"
                                    [btnClass]="'rounded-button--button-black-solid'"
                                    (onClick)="assignBibs()">
                  <i class="bi bi-list-ol pe-2"></i>
                </app-rounded-button>
              </div>
            </div>
          </div>
        </app-admin-actions-header>
      </div>
    </app-competitor-table>
    @if (showFabButton && (competitors?.length ?? 0) > 0) {
      <div (click)="scrollToTop()" class="scroll-to-top">
        <i class="bi bi-arrow-up"></i>
      </div>
    }
  </div>
</ng-container>
